import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'app/services/employee.service';
import { timezone } from 'assets/constants/timezone';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-create-employee',
  templateUrl: './create-employee.component.html',
  styleUrls: ['./create-employee.component.scss']
})
export class CreateEmployeeComponent implements OnInit {

  employeeForm: FormGroup;
  isSaving = false;
  userId: string;
  userName: string;

  constructor(
    private fb: FormBuilder,
    protected employeeService: EmployeeService,
    protected auth: AngularFireAuth,
    public ngbActiveModal: NgbActiveModal
  ) {
    this.employeeForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      email: [null, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      password: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(16)]],
      entranceDate: [null, Validators.required],
      phone: [null, Validators.required],
      description: [null, Validators.required],
      role: [null, Validators.required]
    });
    this.userName = localStorage.getItem("userName") || "Not found user";
    this.userId = localStorage.getItem("userId") || "Not found user";
  }

  ngOnInit(): void {
  }

  save(): void {
    this.isSaving = true;
    this.auth.createUserWithEmailAndPassword(this.employeeForm.value.email, this.employeeForm.value.password).then((authStatus: any) => {
      const newEmployee = {
        ...this.employeeForm.value,
        id: authStatus.user!.uid,
        createdAt: dayjs().tz(timezone).unix(),
        createdById: this.userId,
        createdByName: this.userName,
        indicators: [],
        fullName: `${this.employeeForm.value.name} ${this.employeeForm.value.lastName}`,
        searchingProperty: `${this.employeeForm.value.name} ${this.employeeForm.value.lastName}`.toLowerCase()
      };
      this.employeeService.createEmployee(newEmployee).then(() => {
        this.ngbActiveModal.close({
          success: true
        });
      }).catch((error: any) => {
        console.error("Employee create error =>", error);
        this.ngbActiveModal.close({
          error,
          success: false
        });
      });
    }).catch((errorAuth: any) => {
      console.error("Error auth =>", errorAuth);
      this.ngbActiveModal.close({
        success: false
      });
    });
  }

}
